export enum AccessTargetEnum {
	/** Таргет доступа к оформлению заявок */
	NewBuy = 'NewBuy',
	/** Таргет получения привязанных ТС для оформления заявок */
	LinkedVehicle = 'LinkedVehicle',
	/** Таргет получения всех ТС клиента (по ДФЛ и из автопарка) для оформления заявок  */
	AllVehicle = 'AllVehicle',
	/**  Таргет доступа к заявкам по договорам, относящиеся к автомобилю */
	DriverContractRequests = 'DriverContractRequests',
	/** Таргет доступа к оформлению всех заявок по договорам*/
	AllContractRequests = 'AllContractRequests',
	/** Таргет доступа к заявкам, оформленные текущей УЗ */
	PersonalRequestStatuses = 'PersonalRequestStatuses',
	/** Таргет доступа к заявкам, относящиеся к автомобилю */
	DriverContractRequestStatuses = 'DriverContractRequestStatuses',
	/** Таргет доступа получения всех заявок клиента*/
	AllRequestStatuses = 'AllRequestStatuses',
	/** Таргет доступа к разделу "Договоры и страховка" */
	ContractsAndInsurance = 'ContractsAndInsurance',
	/** Таргет доступа к разделу "Бухгалтерия" */
	AccountingDepartment = 'AccountingDepartment',
	/** Таргет доступа к созданию УЗ с ролью Пользователя */
	CreateAccountUser = 'CreateAccountUser',
	/** Таргет доступа к созданию УЗ с ролью Водитель*/
	CreateAccountDriver = 'CreateAccountDriver',
	/** Таргет доступа к созданию УЗ с ролью Управленца автопарка */
	CreateAccountDriverManager = 'CreateAccountDriverManager',
	/** Таргет доступа к созданию УЗ с ролью Бухгалтера */
	CreateAccountManager = 'CreateAccountManager',
	/** Администратор */
	Admin = 'Admin',
	/** Таргет доступа к оформлению заявок по договорам для пользователей с ролью User и Driver */
	UserContractRequests = 'UserContractRequests',
}
